import { useCallback, useEffect, useState } from "react";
import {
  getInvoicePrintDarkTheme,
  setInvoicePrintDarkTheme,
  subscribeInvoicePrintTheme,
} from "utils/invoicePrintTheme";

export const useInvoicePrintTheme = () => {
  const [darkPrint, setDarkPrintState] = useState(getInvoicePrintDarkTheme);

  useEffect(() => subscribeInvoicePrintTheme(setDarkPrintState), []);

  const setDarkPrint = useCallback((value) => {
    setDarkPrintState(value);
    setInvoicePrintDarkTheme(value);
  }, []);

  return { darkPrint, setDarkPrint };
};
